<template>
  <section class="c-section c-section--default">
    <div class="c-section__header">
      <slot name="headerLeft">
        <h2
          v-dompurify-html="$section.sectionHeader"
          class="o-typography__headline5"
        ></h2>
      </slot>
      <slot name="headerRight"></slot>
    </div>
    <div
      ref="slider"
      class="c-section__container"
    >
      <ui-tile
        v-for="product in $section.products"
        :key="product.id"
        :product="product"
        :layout="layout(product.type)"
        class="c-tile--default"
      ></ui-tile>
    </div>
  </section>
</template>
<script>
  import { EventType, ProductType, TileLayout } from '@/shared/enums';
  import { expandTileMixin } from '@/index/shared/mixins';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
    },
    mixins: [
      expandTileMixin,
    ],
    data() {
      return {
        scale: { x: 2, y: 2, z: 2 },
      };
    },
    watch: {
      '$section.products': 'setSectionWidth',
    },
    mounted() {
      this.setSectionWidth();
      this.$EventBus.on(EventType.RESIZE, this.setSectionWidth);
    },
    beforeDestroy() {
      this.$EventBus.off(EventType.RESIZE, this.setSectionWidth);
    },
    methods: {
      layout(productType) {
        return productType === ProductType.PROGRAMME ? TileLayout.LIVE : TileLayout.TRAILER;
      },
      expand(vTile) {
        const tile = vTile.$el;
        const isLast = !tile.nextElementSibling || tile.offsetTop < tile.nextElementSibling.offsetTop;
        const isFirst = !tile.previousElementSibling || tile.offsetTop > tile.previousElementSibling.offsetTop;

        this.delayedExpand(vTile, isFirst, isLast);
      },
      shiftPrevious(tile, offset = 0) {
        const currentTileOffset = tile.offsetTop;

        while (tile.previousElementSibling && tile.previousElementSibling.offsetTop >= currentTileOffset) {
          tile = tile.previousElementSibling;
          tile.style.transform = this.buildStyleString(offset);
        }
      },
      setSectionWidth() {
        if (!this.$refs.slider) {
          return;
        }

        const sectionWidth = this.$refs.slider.getBoundingClientRect().width;
        this.$el.style.setProperty('--section-width', `${sectionWidth}px`);
      },
      shiftNext(tile, offset = 0) {
        const currentTileOffset = tile.offsetTop;

        while (tile.nextElementSibling && tile.nextElementSibling.offsetTop <= currentTileOffset) {
          tile = tile.nextElementSibling;
          tile.style.transform = this.buildStyleString(offset);
        }
      },
    },
  };
</script>
